<template>
    <div id="testDetail" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
      <div v-if="loading" class="loadingAlert">
          <el-alert
              title="加载中"
              description="正在加载数据,这可能需要一些时间,请稍后..."
              type="warning"
              center
              show-icon
              :closable="false">
          </el-alert>
      </div>
      <el-dialog title="交卷" :visible.sync="isShowConfimSubmit" :width="$root.isMob() ? '80%' : '30%'">
        <span v-if="!isPractice">确定要提前交卷吗?</span>
        <span v-if="isPractice">确定要交卷吗?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowConfimSubmit = false">取 消</el-button>
          <el-button type="primary" @click="submit(false)">确 定</el-button>
        </span>
      </el-dialog>

      <div class="title">
        <h2 v-if="!isPractice"><i class="el-icon-s-claim icon"></i>试卷答题-{{ title }}</h2>
        <h2 v-if="isPractice"><i class="el-icon-document icon"></i>{{ title }}</h2>
        <el-button v-if="!isStart && !$root.isMob()" size="small" @click="$emit('return')"><i class="el-icon-back"></i>返回</el-button>
      </div>
      <div class="alert" v-if="!isStart && !isPractice">
        <div class="content">
          <div class="box">
            <h1 class="normal">考前须知</h1>
            <h1>本次考试限时{{(time / 60).toFixed(0)}}分钟，请仔细阅读以下内容后，超时将会自动提交试卷。</h1>
            <h2>点击“开始计时”按钮进行考试。</h2>
            <div>
              本次考试共<span>4</span>种题型，分别为：<span>判断题、选择题、填空题、问答题</span>。
            </div>
            <div>
              判断题共<span>{{ judge_nums }}</span>题，每题<span>{{ judge_score }}</span>分,共<span>{{ judge_nums*judge_score }}</span>分。
            </div>
            <div>
              选择题共<span>{{ select_nums }}</span>题，每题<span>{{ select_score }}</span>分,共<span>{{ select_nums*select_score}}</span>分。
            </div>
            <div>
              填空题共<span>{{ blank_nums }}</span>题，每题<span>{{ blank_score }}</span>分,共<span>{{ blank_nums*blank_score }}</span>分。
            </div>
            <div>
              问答题共<span>{{ question_nums }}</span>题，每题<span>{{ question_score }}</span>分,共<span>{{ question_nums*question_score }}</span>分。
            </div>
          </div>
          
          <el-button type="primary" :class="!canBeStart ? 'isDisabled' : ''" @click="isStart = true" :disabled="!canBeStart">
            <div v-if="canBeStart == false">我已阅读并知晓，开始计时({{ readmeTime }}秒后可点击)</div>
            <div v-else>我已阅读并知晓，开始计时</div>
          </el-button>
        </div>
      </div>

      <div class="alert" v-if="!isStart && isPractice">
        <div class="content">
          <div class="box">
            <h1 class="normal">练习须知</h1>
            <h2>点击“开始练习”按钮进行考试。</h2>
            <h4>练习模式使用AI评分，评分结果仅供参考，不作为实际考试的评分依据。</h4>
            <div>练习模式不限时间，系统将自动从题库中随机抽取题目。</div>            
            <div>
              本次练习共<span>4</span>种题型，分别为：<span>判断题、选择题、填空题、问答题</span>。
            </div>
            <div>
              判断题共<span>{{ judge_nums }}</span>题，每题<span>{{ judge_score }}</span>分,共<span>{{ judge_nums*judge_score }}</span>分。
            </div>
            <div>
              选择题共<span>{{ select_nums }}</span>题，每题<span>{{ select_score }}</span>分,共<span>{{ select_nums*select_score}}</span>分。
            </div>
            <div>
              填空题共<span>{{ blank_nums }}</span>题，每题<span>{{ blank_score }}</span>分,共<span>{{ blank_nums*blank_score }}</span>分。
            </div>
            <div>
              问答题共<span>{{ question_nums }}</span>题，每题<span>{{ question_score }}</span>分,共<span>{{ question_nums*question_score }}</span>分。
            </div>
          </div>
          
          <el-button type="primary" :class="!canBeStart ? 'isDisabled' : ''" @click="isStart = true" :disabled="!canBeStart">
            <div v-if="canBeStart == false">我已阅读并知晓，开始练习({{ readmeTime }}秒后可点击)</div>
            <div v-else>我已阅读并知晓，开始练习</div>
          </el-button>
        </div>
      </div>


      <div class="alert" v-if="isEnd">
        <div class="content" v-loading="loading">
          <h1>本次考试已超时 已自动提交试卷</h1>
          <el-button type="primary" @click="$emit('return')">返回</el-button>
        </div>
      </div>

      <div  v-if="showList && isStart && !isEnd && $root.isMob()" class="submitBtn">
        <el-button v-if="isPractice" @click="reloadData()">刷新题库</el-button>
        <el-button type="primary" @click="isShowConfimSubmit = true">交卷</el-button>
      </div>

      <div :class="timeBoxClass" v-if="showList && isStart && !isEnd && $root.isMob()">
        <div class="time">
          <el-progress :width="50" v-if="!isPractice" type="circle" :percentage="timeProgress" :color="progressColors" :format="timeFormat"></el-progress>
          <el-progress :width="50" v-if="isPractice" type="circle" :percentage="100" :color="progressColors" :format="timeFormat"></el-progress>
        </div> 
      </div>

      <div :class="timeBoxClass" v-if="showList && isStart && !isEnd && !$root.isMob()" ref="dragContainer" class="drag-container" @mousedown="startDrag">
        <div class="time">
          <div class="text"><i class="el-icon-time icon"></i>剩余时间</div>
          <el-progress v-if="!isPractice" type="circle" :percentage="timeProgress" :color="progressColors" :format="timeFormat"></el-progress>
          <el-progress v-if="isPractice" type="circle" :percentage="100" :color="progressColors" :format="timeFormat"></el-progress>
        </div>        
        <div class="buttonBox">
          <el-button v-if="isPractice" @click="reloadData()">刷新题库</el-button>
          <el-button type="primary" @click="isShowConfimSubmit = true">交卷</el-button>
        </div>
      </div>
      <div class="list" v-if="showList && isStart && !isEnd">
        <div class="bigItems">
          <div class="type">
            <h2>一、判断题(每题{{judge_score}}分,共{{ judge_nums*judge_score }}分)</h2>
            <div class="item" v-for="(item,index) in data0" :key="index+'_'+item.name">
              <span>{{ index+1 }}. {{ item.name }}</span>

              <el-radio-group size="mini" v-model="form.judge_datas[item.id]" :fill="'#5e8743'">
                <el-radio-button :label="'2'">
                  <template>
                    <i class="el-icon-check icon"></i>
                  </template>
                </el-radio-button>
                <el-radio-button :label="'1'">
                  <template>
                    <i class="el-icon-close icon"></i>
                  </template>
                </el-radio-button>
              </el-radio-group>

              <div class="itemImgBox" v-if="item.cover_img.length > 0">
                <div class="itemImg" v-for="(img,imgIndex) in item.cover_img" :key="item.id+'_img_'+imgIndex">
                  <el-image 
                    style="width: 100%;"
                    :src="img" 
                    :preview-src-list="item.cover_img">
                  </el-image>
                </div>
              </div>
            </div>
          </div>

          <div class="type">
            <h2>二、选择题(每题{{select_score}}分,共{{ select_nums*select_score }}分)</h2>
            <div class="item" v-for="(item,index) in data1" :key="index+'_'+item.name">
              <span>{{ index+1 }}. {{ item.name }}</span>
              <div style="width:100%">
                <el-radio-group class="radioBox" v-model="form.select_datas[item.id]" :fill="'#5e8743'">
                  <el-radio-button :label="option.option_key"  v-for="option in item.options_text" :key="'op_'+item.id+'_'+option.option_title">
                    <template>
                      {{ option.option_key+'.'+option.option_title }}
                    </template>
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="itemImgBox" v-if="item.cover_img.length > 0">
                <div class="itemImg" v-for="(img,imgIndex) in item.cover_img" :key="item.id+'_img_'+imgIndex">
                  <el-image 
                    style="width: 100%;"
                    :src="img" 
                    :preview-src-list="item.cover_img">
                  </el-image>
                </div>
              </div>
            </div>
          </div>

          <div class="type">
            <h2>三、填空题(每题{{blank_score}}分,共{{ blank_nums*blank_score }}分)</h2>
            <div class="item blank" v-for="(item,index) in data2" :key="index+'_'+item.name">
              <span>{{ index+1 }}.</span>
              <span v-for="(part, key) in formattedText(item.name).part" :key="'blank_'+key">
                <span v-if="part === '______'">
                  <input type="text" v-model="form.blank_datas['key' + formattedText(item.name).key[key] + '_'+item.id]" class="blankInput" @input="changeBlank(form.blank_datas['key' + formattedText(item.name).key[key] + '_'+item.id],$event.target)">
                </span>
                <span v-else>{{ part }}</span>
              </span>
              <div class="itemImgBox" v-if="item.cover_img.length > 0">
                <div class="itemImg" v-for="(img,imgIndex) in item.cover_img" :key="item.id+'_img_'+imgIndex">
                  <el-image 
                    style="width: 100%;"
                    :src="img" 
                    :preview-src-list="item.cover_img">
                  </el-image>
                </div>
              </div>
            </div>
          </div>

          <div class="type">
            <h2>四、问答题(每题{{question_score}}分,共{{ question_nums*question_score }}分)</h2>
            <div class="item" v-for="(item,index) in data3" :key="index+'_'+item.name">
              <span>{{ index+1 }}.{{ item.name }}</span>
              <div class="itemImgBox" v-if="item.cover_img.length > 0">
                <div class="itemImg" v-for="(img,imgIndex) in item.cover_img" :key="item.id+'_img_'+imgIndex">
                  <el-image 
                    style="width: 100%;"
                    fit="contain"
                    :src="img" 
                    :preview-src-list="item.cover_img">
                  </el-image>
                </div>
              </div>              
              <el-input type="textarea" :id="'textarea_'+item.id" placeholder="请输入回答" v-model="form.question_datas[item.id]" @input="changeBlank(form.question_datas[item.id],'textarea_'+item.id)">
              </el-input>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'testDetail',
  props: {
    isPractice:{
      type: Boolean,
      default:false
    },
    id: {
      type: Number,
      default:0
    },
    title: {
      type: String,
      default:''
    }
  },
  watch: {
    "isStart": function(val){
      if(val == true){
        this.startTime();
      }
    },
    "time":function(val){
      if(val <= 0 && this.isEnd == false && !this.isPractice){
        this.submit(true);
        this.isEnd = true;
      }
    },
    "isPractice":function(){
      //重置所有参数
      this.loading = true
      this.data0 = []
      this.data1 = []
      this.data2 = []
      this.data3 = []
      this.blank_score = 0
      this.blank_nums = 0
      this.judge_nums = 0
      this.judge_score = 0
      this.question_nums = 0
      this.question_score = 0
      this.select_nums = 0
      this.select_score = 0
      this.paper_id = 0
      this.form = {}
      this.showList = false
      this.isStart = false
      this.isEnd = false
      this.isShowConfimSubmit = false
      this.canBeStart = false
      this.readmeTime = 5
      this.time = 0
      this.timeProgress = 100
      this.timeBoxClass = "timeBox"
      this.progressColors = [
        {color: '#f55b61', percentage: 30},
        {color: '#e6a23c', percentage: 50},
        {color: '#5e8743', percentage: 100}
      ]
      //清除计时器
      clearInterval(this.timer);
      this.getData();
      this.readmeTimeStart();
    }
  },
  data() {
    return {
      API:window.config.api,
      loading:true,
      data0:[],
      data1:[],
      data2:[],
      data3:[],
      blank_score:0,
      blank_nums:0,
      judge_nums:0,
      judge_score:0,
      question_nums:0,
      question_score:0,
      select_nums:0,
      select_score:0,
      paper_id:0,
      form:{},
      showList:false,
      isStart:false,
      isEnd:false,
      isShowConfimSubmit:false,
      canBeStart:false,
      readmeTime:5,
      time:0,
      timeProgress:100,
      timeBoxClass:"timeBox",
      timer: null,
      progressColors: [
        {color: '#f55b61', percentage: 30},
        {color: '#e6a23c', percentage: 50},
        {color: '#5e8743', percentage: 100}
      ]
    }
  },
  methods: {
    async getData(){
      let paperData = {}
      let data = {}
      if(!this.isPractice){        
        paperData = await this.$root.getPaperInfo(this.id);  
        if(paperData){
          this.paper_id = paperData.id;
          this.time = paperData.examine_minutes * 60;
          this.blank_score = paperData.blank_score
          this.blank_nums = paperData.blank_nums
          this.judge_nums = paperData.judge_nums
          this.judge_score = paperData.judge_score
          this.question_nums = paperData.question_nums
          this.question_score = paperData.question_score
          this.select_nums = paperData.select_nums
          this.select_score = paperData.select_score   
          data = await this.$root.getTestsDetail(this.id);
        }
        else{
          this.$emit("return");
        }
      }
      else{
        paperData = await this.$root.getPracticeInfo(this.id);
        if(paperData){
          this.paper_id = paperData.practice_id;
          this.blank_score = paperData.paper_info.blank_score
          this.blank_nums = paperData.paper_info.blank_nums
          this.judge_nums = paperData.paper_info.judge_nums
          this.judge_score = paperData.paper_info.judge_score
          this.question_nums = paperData.paper_info.question_nums
          this.question_score = paperData.paper_info.question_score
          this.select_nums = paperData.paper_info.select_nums
          this.select_score = paperData.paper_info.select_score
          data.data = paperData
        }
        else{
          this.$emit("return");
        }
      }
      
      if(data.data){
        //初始化form
        this.form = {
          judge_datas:[],
          select_datas:[],
          blank_datas:[],
          question_datas:[]
        }
        //推送题型
        this.data0 = data.data.judge_datas;
        this.data1 = data.data.select_datas;
        this.data2 = data.data.blank_datas;
        this.data3 = data.data.question_datas;

        //推送完整的图片URL
        this.data0.forEach(item => {
          item.cover_img.forEach((img, index) => {
            item.cover_img[index] = this.API + img;
          });
        });
        this.data1.forEach(item => {
          item.cover_img.forEach((img, index) => {
            item.cover_img[index] = this.API + img;
          });
        });
        this.data2.forEach(item => {
          item.cover_img.forEach((img, index) => {
            item.cover_img[index] = this.API + img;
          });
        });
        this.data3.forEach(item => {
          item.cover_img.forEach((img, index) => {
            item.cover_img[index] = this.API + img;
          });
        });
      }      
      this.showList = true;
      this.loading = false;

      //平滑滚动到顶部
      this.$nextTick(() => {
        this.$root.goTop();
      });
    },
    fillAnswers(target){
      let item = this.$refs[target][0];
      item.classList.remove('isEmpey');
    },
    confimSubmit(){
      this.isShowConfimSubmit = true;
    },
    async submit(isTimeout){
      this.loading = true;

      //组装form
      let resultForm = [];

      //判断题S
      this.form.judge_datas.forEach((item,key) => {
        resultForm.push({
          test_id : key,
          answer : item
        })
      });
      //判断题E

      //选择题S
      this.form.select_datas.forEach((item,key) => {
        resultForm.push({
          test_id : key,
          answer : item
        })
      });
      //判断题E
      
      //填空题S
      Object.keys(this.form.blank_datas).forEach(item => {        
        let oldItem = item;
        let key = oldItem.replaceAll('key','');
        key = key.split('_')[0];
        item = item.split('_')[1];

        //查找test_id是否已存在与resultForm
        let isExist = false;
        resultForm.forEach(formItem => {
          if(formItem.test_id == item){
            isExist = true;
          }
        });
        if(!isExist){
          resultForm.push({
            test_id : item,
            answer : {}
          });
        }

        resultForm.forEach(formItem => {
          if(formItem.test_id == item){
            formItem.answer[key] = this.form.blank_datas[oldItem];
          }
        });        
      });
      //填空题E

      //问答题S
      this.form.question_datas.forEach((item,key) => {
        resultForm.push({
          test_id : key,
          answer : item
        })
      });
      //问答题E

      let res = null;
      if(!this.isPractice){
        let data = {
          paper_id : this.paper_id,
          answers : resultForm
        };
        res = await this.$root.submitTests(data);
      }
      else{
        let data = {
          practice_id : this.paper_id,
          answers : resultForm
        };
        res = await this.$root.submitPractice(data);
      }
      this.loading = false;
      this.$notify({
          type: 'success',
          title: '通知',
          message: res.msg
      });
      if(!isTimeout){
        this.$emit('return');
      }
    },
    startTime(){  
      let orgTime = this.time;
      let flag = false;
      let timer = setInterval(() => {
        this.time--
        //计算百分比
        this.timeProgress = this.time/orgTime * 100;
        if(this.timeProgress <= 50 && this.timeProgress > 30 && this.timeBoxClass == "timeBox"){
          this.timeBoxClass = "timeBox shake";
        }
        if(this.timeProgress <= 30 && this.timeProgress > 0 && this.timeBoxClass == "timeBox"){
          flag = true;
          this.timeBoxClass = "timeBox shake";
        }
        if(this.timeProgress <= 31 && this.timeProgress > 0 && this.timeBoxClass == "timeBox shake" && flag == false){
          this.timeBoxClass = "timeBox";
        }
        if(this.time <= 0){
          clearInterval(timer);
        }
      }, 1000);
    },
    timeFormat(){
      if(this.isPractice){
        return "无限";
      }
      return this.time.toString().length == 1 ? '0'+ this.time + '秒' : this.time + '秒';
    },
    startDrag(e) {
      this.isDragging = true;
      // 计算鼠标相对于容器的偏移量
      this.offsetX = e.clientX - this.$refs.dragContainer.offsetLeft;
      this.offsetY = e.clientY - this.$refs.dragContainer.offsetTop;
      // 绑定鼠标移动和释放事件
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    onDrag(e) {
      if (this.isDragging) {
        const container = this.$refs.dragContainer;
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;

        let newLeft = e.clientX - this.offsetX;
        let newTop = e.clientY - this.offsetY;

        // 限制容器不能超出屏幕左边和右边
        if (newLeft < 0) {
          newLeft = 0;
        } else if (newLeft + containerWidth > window.innerWidth) {
          newLeft = window.innerWidth - containerWidth;
        }

        // 限制容器不能超出屏幕上边和下边
        if (newTop < 0) {
          newTop = 0;
        } else if (newTop + containerHeight > window.innerHeight) {
          newTop = window.innerHeight - containerHeight;
        }

        // 更新容器位置
        container.style.left = `${newLeft}px`;
        container.style.top = `${newTop}px`;
      }
    },
    stopDrag() {
      this.isDragging = false;
      // 移除鼠标移动和释放事件的监听
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    formattedText(name) {
      const parts = name.split(/(______)/);
      let blankKeys = []; // 清空之前的键
      let blankNO = 1;
      for (let i = 0; i < parts.length; i++) {
        if (parts[i] === '______') {
          // 每当遇到 '______'，就为它生成一个唯一的键并存储
          blankKeys.push(blankNO++);
        } else {
          blankKeys.push(null); // 非空白部分不需要唯一键
        }
      }
      return {part:parts,key:blankKeys};
    },
    changeBlank(value,target){
      if(value){
        if(target){
          if(target.tagName == 'INPUT'){
            target.style.width = value.length + 'em';
          }
          else{
            //判断value中有几个换行
            let newLine = value.split('\n').length;
            if(newLine > 1){
              document.getElementById(target).rows = newLine;
            }            
          }
        }               
      }
    },
    readmeTimeStart(){
      this.timer = setInterval(() => {
        this.readmeTime--;
        if(this.readmeTime <= 0){
          this.canBeStart = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    reloadData(){
      this.getData();
    },
  },
  created() {
    this.getData();
    this.readmeTimeStart();
  },
  destroyed(){
    //清除计时器
    clearInterval(this.timer);
  }
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/testsDetail.scss">

</style>